import { db } from '@/features/offline/db'
import { APP_VERSION, neueFunktionen, type Aenderung } from './fassungen'

/**
 * Welche Fassung der Nutzer zuletzt zur Kenntnis genommen hat.
 *
 * Gleiches Vorgehen wie beim Kartenstand in `@/features/updates/diff`: Der Wert steht
 * in der lokalen Datenbank, nicht im `localStorage` — er gehört zu den Daten der App
 * und soll dieselbe Lebensdauer haben wie Favoriten und heruntergeladene Karten.
 */

const SCHLUESSEL = 'changelog:gesehen'

export async function leseGesehen(): Promise<string | null> {
  const eintrag = await db.settings.get(SCHLUESSEL)

  return typeof eintrag?.value === 'string' ? eintrag.value : null
}

/** Hält fest, dass der Nutzer die Neuerungen dieser Fassung gesehen hat. */
export async function merkeGesehen(version: string = APP_VERSION): Promise<void> {
  await db.settings.put({ key: SCHLUESSEL, value: version })
}

/**
 * Was ist seit dem letzten Öffnen an Funktionen hinzugekommen?
 *
 * Steht noch nichts in der Datenbank, wird die laufende Fassung still übernommen und
 * nichts gemeldet. Das deckt zwei Fälle mit derselben Regel ab, und beide verlangen
 * dasselbe:
 *
 * - **Erstinstallation.** Für diesen Nutzer ist die gesamte App neu; ihn mit einer
 *   Liste aller je gebauten Funktionen zu begrüßen, sagt ihm nichts.
 * - **Update von einer Fassung vor Einführung dieses Verlaufs.** Technisch nicht von
 *   der Erstinstallation zu unterscheiden — und es wäre auch nicht richtig, dort
 *   plötzlich vier Fassungen auf einmal aufzuzählen.
 *
 * Danach bleibt der gespeicherte Stand unangetastet, bis der Nutzer den Hinweis
 * bestätigt. Sonst verschwände er beim nächsten Öffnen von selbst, obwohl ihn niemand
 * gelesen hat — dieselbe Entscheidung wie beim Änderungshinweis für Karten.
 */
export async function ermittleNeuerungen(): Promise<Aenderung[]> {
  const gesehen = await leseGesehen()
  if (gesehen === null) {
    await merkeGesehen()
    return []
  }

  return neueFunktionen(gesehen)
}
